import { render, staticRenderFns } from "./Spinner.vue?vue&type=template&id=bf72f284"
var script = {}
import style0 from "./Spinner.vue?vue&type=style&index=0&id=bf72f284&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports